// ids can arrive as numbers (from as_json / row props) or strings (the position
// effect writes Object.keys) — normalize before comparing so a delete purge and
// an edit merge both match regardless of source type.
const sameId = (a, b) => String(a) === String(b);

// Drop any pending edit for a row from a nested-attributes bucket. Called when a
// row is deleted (via its own targeted request) so a stale by-id update for the
// now-gone row can't re-fire on the next whole-form save and RecordNotFound.
export const withoutNestedEntry = (formState, bucket, id) => {
  const current = formState[bucket] || [];
  const filtered = current.filter((entry) => !sameId(entry.id, id));
  return filtered.length === current.length ? formState : { ...formState, [bucket]: filtered };
};

// Merge a single row's attributes into its own nested-attributes bucket by id,
// leaving the other buckets' pending edits intact. Replacing the whole bucket
// (and zeroing siblings) dropped un-flushed edits when two rows were touched
// inside the debounce window.
export const mergeNestedEntry = (formState, bucket, entry) => {
  const existing = formState[bucket] || [];
  const index = existing.findIndex((candidate) => sameId(candidate.id, entry.id));
  const merged = index >= 0
    ? existing.map((candidate, i) => (i === index ? { ...candidate, ...entry } : candidate))
    : [...existing, entry];
  return { ...formState, [bucket]: merged };
};
